import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OidcAuthService } from '../../services/oidc-auth.service';
import { OidcSecurityService } from '../../lib/angular-auth-oidc-client-facade';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule],
  template: '',
  styles: []
})
export class CallbackComponent implements OnInit {
  constructor(
    private authService: OidcAuthService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    
    if (error) {
      console.error('OAuth error:', error);
      this.router.navigate(['/']);
      return;
    }
    
    if (code && state) {
      await this.authService.handleCallback(code, state);
    }
    
    this.oidcSecurityService.isAuthenticated$
      .pipe(filter((isAuthenticated: boolean) => isAuthenticated))
      .subscribe(() => {
        this.router.navigate(['/']);
      });
  }
}